module.exports = {
	"LANGUAGE": "语言",
	"HDR-obpa_fulltext_score": "评分",
	"HDR-obpa_name": "名称",
	"HDR-obpa_fulltext_summary": "摘要",
	"QUERY LIMIT REACHED": "结果比显示的结果多。请缩小搜索条件范围。",
	"NO DOCUMENTS FOUND": "没有找到文件。",
	"OPEN IN NEW WINDOW": "在新窗口中打开",
	"DOWNLOAD NATIVE": "以原生格式下载",
	"CLOSE": "关闭",
	"SEARCH TYPE": "搜索类型",
	"DOCUMENT TYPE": "文档类型",
	"SEARCH TERM": "搜索词",
	"SEARCH": "搜索",
	"RESET": "重置",
	"DATE": "日期",
	"FROM DATE": "开始日期",
	"TO DATE": "结束日期",
	"LOADING": "加载中...",
	"RETRY": "重试",
	"ERROR": "错误！",
	"ERROR: QUERIES": "无法检索搜索类型列表。",
	"ERROR: DOCTYPES": "无法检索文档类型列表。",
	"ERROR: KEYWORDS": "无法检索搜索字段列表。",
	"ERROR: DOCUMENTS": "无法执行请求的搜索。",
	"FORM: INVALID FULLTEXT": "段必须至少为 {{chars}} 个字符。",
	"FORM: INVALID DATE SHORT": "格式： {{format}} .",
	"FORM: REQUIRED KEYWORD": "现场是必需的。",
	"FORM: INVALID NUMERIC": "字段必须是最多 {{digits}} 位数。",
	"FORM: INVALID DATE": "字段必须遵循格式 {{format}} .",
	"FORM: INVALID CURRENCY": "字段必须是有效的货币值。",
	"FORM: INVALID FLOAT": "字段必须是数字。",
	"FORM: INVALID LENGTH": "字段必须最多为 {{chars}} 个字符。",
	"FORM: ERRORS": "表单上有错误。",
	"FORM: noDate": "必须指定日期范围。",
	"FORM: noKeyword": "必须至少指定一个字段。",
	"FORM: noDateOrKeyword": "日期范围或必须至少指定一个字段。",
	"FORM: noDateAndKeyword": "日期范围AND必须至少指定一个字段。"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/zh.json
// module id = 363
// module chunks = 0